import { render, staticRenderFns } from "./Collects.vue?vue&type=template&id=51a3e156"
import script from "./Collects.vue?vue&type=script&lang=js"
export * from "./Collects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports